import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import BiensDuDeal from "./BiensDuDeal";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";


import BackButton from "../Common/BackButton";

export default function DealRealEstates({ id, app }) {
	console.log("DealRealEstates", id);
	const [state, setState] = useState({ loaded: false, mode: "AM", tunnel: false, uid: id });
	useEffect(() => {
		fetch("/api/f37ab7f1a7284e1ebd053bcd35acb51f/" + id + "/0")
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							...res.pld,
							loaded: true,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);


	return (
		<div style="margin: 10px; margin-top: 100px;">
			{/* <ChangePriceDialog state={stateChangePriceDialog} onClose={handleCloseChangePriceDialog} uid={id} /> */}

			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Paper style="padding: 10px;">

						<Box display="flex" justifyContent="space-between" alignItems="center">

							<Box>
								<BackButton tooltip={"Revenir au dossier"} from={(state.mode == "AM"
									? "/7bac6cb9d6ee4d70b1315393725f3a34/" + id
									: state.mode == "VN"
										? "/11d1355181ac4376a09980601b420617/" + id
										: "/login")} />
							</Box>
							<Box>
								<Typography variant="h5">Descriptif des biens</Typography>
							</Box>
							<Box>
								{state.assets && state.assets.length > 0 && (
									<Button
										variant="contained"
										onClick={() => {
											setState((state) => ({ ...state, new_one: true }));
										}}
									>
										Ajouter un bien
									</Button>
								)}
							</Box>
						</Box>
					</Paper>
				</Grid>

				<Grid item xs={12}>
					<Paper style="padding: 10px;">
						<BiensDuDeal setUpperState={setState} upperState={state} />
					</Paper>
				</Grid>
			</Grid>
		</div>
	);
}
